module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', [_c('td', [_c('tr', [_c('td', {
    staticClass: "no-border-and-padding"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerPeriod.startOfPeriod),
      expression: "innerPeriod.startOfPeriod"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "startOfPeriod",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.innerPeriod.startOfPeriod)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerPeriod, "startOfPeriod", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.retirementDate !== '' && _vm.innerPeriod.startOfPeriod === _vm.retirementDate) ? _c('td', {
    staticClass: "no-border-and-padding td-icon-space"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "identifier",
      "tooltip-text": "This period has been split automatically at the age at which this person retires. You can still change this manually.",
      "side": "right",
      "text-width": "300",
      "icon-type": "info"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('td', [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control.required",
      value: ({
        type: 'date',
        name: 'endOfPeriod' + _vm.index
      }),
      expression: "{type:'date', name:'endOfPeriod' + index}",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "emit": true
    },
    on: {
      "input": function($event) {
        return _vm.updateNextPeriod()
      }
    },
    model: {
      value: (_vm.innerPeriod.endOfPeriod),
      callback: function($$v) {
        _vm.$set(_vm.innerPeriod, "endOfPeriod", $$v)
      },
      expression: "innerPeriod.endOfPeriod"
    }
  })], 1), _vm._v(" "), (!_vm.retired) ? _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerPeriod.employmentType),
      expression: "innerPeriod.employmentType"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.innerPeriod, "employmentType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updatePeriod()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "employed"
    }
  }, [_vm._v("Employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "self_employed"
    }
  }, [_vm._v("Self-employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "part_employed"
    }
  }, [_vm._v("Part-employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "not_employed"
    }
  }, [_vm._v("Not employed")])])]) : _vm._e(), _vm._v(" "), (!_vm.retired) ? _c('td', [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerPeriod.employmentIncome),
      expression: "innerPeriod.employmentIncome",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control.required",
      value: ({
        type: 'number',
        name: 'employmentIncome' + _vm.index
      }),
      expression: "{type:'number', name:'employmentIncome' + index}",
      modifiers: {
        "required": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.innerPeriod.employmentIncome)
    },
    on: {
      "focus": function($event) {
        _vm.innerPeriod.employmentIncome = _vm.innerPeriod.employmentIncome || ''
      },
      "blur": [function($event) {
        _vm.innerPeriod.employmentIncome = _vm.innerPeriod.employmentIncome || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerPeriod, "employmentIncome", _vm._n($event.target.value))
      }, function($event) {
        return _vm.updatePeriod()
      }]
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.retired) ? _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerPeriod.employmentNetGross),
      expression: "innerPeriod.employmentNetGross"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.innerPeriod, "employmentNetGross", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updatePeriod()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "net"
    }
  }, [_vm._v("Net")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "gross"
    }
  }, [_vm._v("Gross")])])]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerPeriod.pensionIncome),
      expression: "innerPeriod.pensionIncome",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control.required",
      value: ({
        type: 'number',
        name: 'pensionIncome' + _vm.index
      }),
      expression: "{type:'number', name:'pensionIncome' + index}",
      modifiers: {
        "required": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.innerPeriod.pensionIncome)
    },
    on: {
      "focus": function($event) {
        _vm.innerPeriod.pensionIncome = _vm.innerPeriod.pensionIncome || ''
      },
      "blur": [function($event) {
        _vm.innerPeriod.pensionIncome = _vm.innerPeriod.pensionIncome || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerPeriod, "pensionIncome", _vm._n($event.target.value))
      }, function($event) {
        return _vm.updatePeriod()
      }]
    }
  })])]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerPeriod.pensionNetGross),
      expression: "innerPeriod.pensionNetGross"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.innerPeriod, "pensionNetGross", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updatePeriod()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "net"
    }
  }, [_vm._v("Net")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "gross"
    }
  }, [_vm._v("Gross")])])]), _vm._v(" "), (!_vm.retired) ? _c('td', [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerPeriod.totalGrossIncome),
      expression: "innerPeriod.totalGrossIncome",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.innerPeriod.totalGrossIncome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerPeriod, "totalGrossIncome", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.innerPeriod.totalNetIncome),
      expression: "innerPeriod.totalNetIncome",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.innerPeriod.totalNetIncome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.innerPeriod, "totalNetIncome", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), (this.index === 0) ? _c('td', [_c('div', {
    class: {
      'a-loader--total': _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('button', {
    staticClass: "a-button a-button--delete a-button--delete-disabled a-button--small",
    attrs: {
      "role": "button",
      "type": "button",
      "disabled": "disabled"
    }
  }) : _vm._e()]) : _c('td', [_c('div', {
    class: {
      'a-loader--total': _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('button', {
    staticClass: "a-button a-button--delete a-button--small",
    attrs: {
      "role": "button",
      "type": "button"
    },
    on: {
      "click": _vm.deletePeriod
    }
  }) : _vm._e()])]), _vm._v(" "), (!_vm.endOfPeriodRules) ? _c('tr', {
    staticClass: "a-table--error"
  }, [_c('td', {
    attrs: {
      "colspan": !_vm.retired ? 10 : 6
    }
  }, [_c('control-error', [_vm._v("\n                The income period end date can not be before the deceased's date of death and\n                cannot be after the deceased's 'but for' date of death\n            ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.retired && !_vm.incomeRules && this.dependant === null) ? _c('tr', {
    staticClass: "a-table--error"
  }, [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('control-error', [_vm._v("\n                The Pension Income must be greater than £0.00\n            ")])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.retired && !_vm.incomeRules && this.dependant === null) ? _c('tr', {
    staticClass: "a-table--error"
  }, [_c('td', {
    attrs: {
      "colspan": "10"
    }
  }, [_c('control-error', [_vm._v("\n                The Pension Income OR Employment Income must be greater than £0.00\n            ")])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.endValid) ? _c('tr', {
    staticClass: "a-table--error"
  }, [_c('td', {
    attrs: {
      "colspan": "10"
    }
  }, [_c('control-error', [_vm._v("\n                The end date of a period must be at least one day after the start.\n            ")])], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-24e7f7ed!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/fatal-accident-claims/dependency/steps/dependency-on-income/IncomePeriod.vue
// module id = 1613
// module chunks = 0